import { ABC, Availability, Brand, Cotton, Fabric, Instock, Pixelstrap, Seller } from "../../../../Constant";

export const ProductTable = () => {
  return (
    <>
      <div>
        <table className="product-page-width">
          <tbody>
            <tr>
              <td className="f-w-700">
                <b>{Brand} &nbsp;&nbsp;&nbsp;:</b>
              </td>
              <td>{Pixelstrap}</td>
            </tr>
            <tr>
              <td className="f-w-700">
                <b>{Availability} &nbsp;&nbsp;&nbsp;: &nbsp;&nbsp;&nbsp;</b>
              </td>
              <td className="txt-success">{Instock}</td>
            </tr>
            <tr>
              <td className="f-w-700">
                <b>{Seller} &nbsp;&nbsp;&nbsp;: &nbsp;&nbsp;&nbsp;</b>
              </td>
              <td>{ABC}</td>
            </tr>
            <tr>
              <td className="f-w-700">
                <b>{Fabric} &nbsp;&nbsp;&nbsp;: &nbsp;&nbsp;&nbsp;</b>
              </td>
              <td>{Cotton}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr />
    </>
  );
};
